import React from 'react';
import { AttributeGroupRules } from '../../../_lib/components/AttributeGroupRules/AttributeGroupRules';

export type AttributeGroupInfoRules = AttributeGroupRules;

export function AttributeGroupInfoRules({ ruleCombination, rules }: AttributeGroupRules) {
  return (
    <div className="attribute-group-info">
      <AttributeGroupRules rules={rules} ruleCombination={ruleCombination} />
    </div>
  );
}
